/**
 * @file Preview modal for identity selfie review page.
 */

import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../global/modal/withModal';
import { PHOTO_MODAL } from '../../constants/modals';

const propTypes = {
  actionProps: PropTypes.shape({
    photoUrl: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
};

const PhotoModal = ({ actionProps: { photoUrl } = {}, className }) => (
  <div className={className}>
    <img src={photoUrl} alt="" />
  </div>
);

PhotoModal.propTypes = propTypes;

export default withModal(PhotoModal, {
  name: PHOTO_MODAL,
  size: 'sm',
});
